import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const active = this.element.querySelector(".nav-link.active")
    if (active) {
      active.scrollIntoView({ block: "center" })
    }
  }
}
